export const Corporation = {
  Header: {
    LinkCancellation: '法人向け健康サポート利用解除',
  },
  Description: {
    AccountLinkDescription:
      '当サービスはタヨリス提携先の法人向けとなります。タヨリス提携先の法人に所属されている場合、お手元に届いている認証コードと企業設定日を入力ください。',
  },
  Label: {
    CertificationCode: {
      Text: '認証コード',
    },
    CompanySetupDate: {
      Text: '企業設定日',
    },
    CorporateUserID: {
      Text: '従業員番号',
    },
  },
  LinkButton: {
    Text: '利用開始',
  },
  LinkCancellationButton: {
    Text: '利用解除',
  },
  Dialog: {
    LinkedAccount: {
      Title: {
        Text: '法人向け健康サポートの利用を開始しました。',
      },
      Button: {
        Text: 'OK',
      },
    },
    LinkedCancellation: {
      Text: '法人向け健康サポートの利用を解除します。本当によろしいですか？',
    },
  },
  Validation: {
    InvalidAlphaNumericAndMore10: '半角英数字10桁以上で入力してください。',
  },
};
